import { NavLink } from "react-router-dom";

const NavbarLink = ({ to, label, icon, end = "false" }) => {
  return (
    <NavLink
      to={to}
      exact="true"
      end={end}
      className={({ isActive }) => `${isActive && 'text-ase-blue bg-ase-blue bg-opacity-10 rounded-md'} text-lg md:text-sm px-2 py-2 md:py-1 flex items-center gap-2 md:gap-2 hover:text-ase-blue transition-all`}
    >
      {icon ? icon : null} {label}
    </NavLink>
  )
}

export default NavbarLink;
